import angular, { IHttpProvider } from 'angular'

/**
 * Setup application wide interceptors
 *
 * @module config.api-interceptor-config
 */
angular.module('webregister').config(function ($httpProvider: IHttpProvider) {
  $httpProvider.interceptors.push('redirectOnRedirect')
  $httpProvider.interceptors.push('abortRequestWhenOffline')
  $httpProvider.interceptors.push('apiIdentification')
  $httpProvider.interceptors.push('redirectSigninOn401')
  $httpProvider.interceptors.push('redirectBillingOn402')
})
